var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import StageForm from "./StageForm";
import StageService from "../../../Services/Stage.service";
import StageTypeDomainService from "../../../Domain/StageType/StageType.service";
const EditStageModal = (_a) => {
    var { stage } = _a, modalProps = __rest(_a, ["stage"]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Edit Stage", defaultValue: {
            id: stage.id,
            name: stage.name,
            description: stage.description,
            isEndingStage: stage.stageType.id !== StageTypeDomainService.NONE_ID,
            stageType: stage.stageType.id === StageTypeDomainService.NONE_ID
                ? undefined
                : stage.stageType,
        }, handleSubmit: (state) => __awaiter(void 0, void 0, void 0, function* () {
            var _b, _c;
            if (!state.id) {
                throw "Stage id not provided";
            }
            return StageService.edit({
                stageId: state.id,
                validationRules: null,
                name: state.name,
                description: state.description,
                position: null,
                stageTypeId: (_c = (_b = state.stageType) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : StageTypeDomainService.NONE_ID,
            });
        }), children: _jsx(StageForm, {}) })));
};
export default EditStageModal;
